import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CustomLabelCss, LabelType } from '../models/label.model';

const PRE_LABEL_CLASS = 'ui-label--';

@Component({
  selector: 'ui2-label',
  templateUrl: './ui2-label.component.html',
  styleUrls: ['./ui2-label.component.scss']
})
export class Ui2LabelComponent implements OnInit, OnChanges {
  // Label type solid solid/outline
  @Input() private labelType: LabelType = LabelType.SOLID;

  // Custom label color
  @Input() private labelColor: string;
  // Custom background color
  @Input() private bgColor: string;

  // Text to display
  @Input() public text: string;

  // Custom width for label
  @Input() public labelWidth: string;

  // Custom min-width for label
  @Input() public labelMinWidth: string;

  // Determine if label has hover state or not
  @Input() private hasHover = false;

  @Output() labelClicked: EventEmitter<null> = new EventEmitter();

  // Class for the label
  public labelClass: string;

  // Custom styling generated according to the LabelType and colors provided
  // bgColor, text color, border color
  public activeCSS: CustomLabelCss;
  private dynamicCSS: CustomLabelCss = {};
  private dynamicHoverCss: CustomLabelCss = {};

  ngOnInit(): void {
    // Show warning if text is not provided
    if (!this.text || !this.text.length) {
      console.warn('Label text is missing! Text is mandatory for displaying labels!');
    }
    // Add custom label class
    this.labelClass = PRE_LABEL_CLASS + this.labelType;

    if (this.hasHover) {
      this.labelClass += ' ui-label--hoverable';
    }

    this.generateCSSObj();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bgColor) {
      this.generateCSSObj();
    }
  }

  /**
   *
   *
   * Generate dynamic CSS object according to the provided configs
   *
   *
   *
   * @returns
   */
  private generateCSSObj(): void {
    switch (this.labelType) {
      case LabelType.OUTLINE:
        if (this.labelColor) {
          this.dynamicCSS = { 'border-color': this.labelColor, color: this.labelColor };
          this.dynamicHoverCss = {
            'background-color': this.labelColor,
            'border-color': this.labelColor
          };
        }

        if (this.bgColor) {
          Object.assign(this.dynamicHoverCss, { 'background-color': this.labelColor });
        }

        break;
      default:
        if (this.bgColor) {
          this.dynamicCSS = { 'background-color': this.bgColor };
        }
        break;
    }

    this.activeCSS = this.dynamicCSS;
  }

  /**
   *
   *
   * On label click output event
   *
   *
   *
   * @returns
   */
  public onLabelClick(): void {
    this.labelClicked.emit();
  }

  /**
   *
   *
   * On Label hover set hover styling as active
   *
   *
   *
   * @returns
   */
  public onLabelHover(): void {
    if (!this.hasHover) {
      return;
    }
    this.activeCSS = this.dynamicHoverCss;
  }

  /**
   *
   *
   * On Label hover out set standard styling as active
   *
   *
   *
   * @returns
   */
  public onLabelHoverOut(): void {
    if (!this.hasHover) {
      return;
    }
    this.activeCSS = this.dynamicCSS;
  }
}
